// @flow strict

import throttle from './throttle';

export default throttle;
export { default as useDebouncedCallback } from './useDebouncedCallback';
export { default as useThrottledCallback } from './useThrottledCallback';
export type { DebounceOptions } from './useDebouncedCallback';
export type { ThrottleOptions } from './useThrottledCallback';
